<template>
  <div class="index-query-dataen" style="height: calc(100% - 175px)">
    <div class="copySel">
      <!-- <span class="copyLab">语言</span>
            <form-select1 
            v-model="lang"
            :options="$getOptions('lang')"
            @change="langChange"
            >
            </form-select1> -->
      <!--<span class="copyLab">查询类型</span>
             <form-select1 
            style="width:400px;"
            v-model="type"
            :options="$getOptions('queryType')"
            @change="typeChange">
            </form-select1> -->
      <base-form
        ref="queryForm"
        v-model="baseQueryFormObj"
        labelWidth="120px"
        :inline="true"
        :form-items="baseFormItems"
      >
      </base-form>
    </div>
    <base-form
      ref="queryForm"
      style="margin-top: -20px"
      v-model="queryFormObj"
      labelWidth="120px"
      :inline="true"
      @keyup.enter.native="enterQuery"
      :form-items="toolbar.formItems"
    >
    </base-form>
    <base-table-new
      :sendJson="true"
      :isSendToken="false"
      ref="table"
      :query="queryFormObj"
      :initSearch="false"
      :actionReload="true"
      url="queryData/get"
      :columns="columns"
    >
    </base-table-new>
  </div>
</template>
<script>
export default {
  name: 'index-query-data',
  data() {
    var brandQueryForm = {
      label: ' 列表类别',
      prop: 'bid',
      labelWidth: '200px',
      component: 'form-select1',
      bind: {
        param: {
          data_type: 1,
        },
        clearable: true,
        sendJson: true,
        isSendToken: false,
        dataKey: {
          label: 'brand',
          value: 'id',
        },
      },
      on: {
        change: this.brandChange,
      },
    }
    return {
      showImportDialog: false,
      userArr: [],
      currSelectIdx: -1,
      baseQueryFormObj: {},
      queryFormObj: {},
      // type:'',
      brandQueryForm: brandQueryForm,
      toolbar: {
        formItems: [],
        query: {},
      },
      baseFormItems: [
        {
          label: '查询类型',
          prop: 'type',
          component: 'form-select',
          bind: {
            options: this.$getOptions('queryType')
          },
          on: {
            change: this.typeChange,
          },
        },
        brandQueryForm,
      ],
      columns: [],
    }
  },
  created() {
    this.$nextTick(() => {
      this.typeChange('tyrePressureFuncQuery')
    })
  },
  methods: {
    success() {},
    enterQuery() {
      this.$refs.table.query.PageIndex = 1
      this.$refs.table.refreshData()
    },
    typeChange(val) {
      var that = this
      //this.$refs.table.query.type=this.type;
      //var relBrandSelect=that.$refs.table.$refs.toolbar.$refs.form.$children[0].$children[0].$children[1];
      // this.formItems[2].bind.url="/brandOrField/get";
      // this.formItems[2].bind.param.type=obj.val;

      var firstFormItem = { ...this.brandQueryForm }
      firstFormItem.bind.url = 'brandOrField/get'
      firstFormItem.bind.param.type = val
      firstFormItem.bind.callBack = (data) => {
        if(data && data.length > 0 && data[0].id) {
          that.$nextTick(() => {
            firstFormItem.value = data[0].id
            that.brandChange({ val: data[0].id })
          })  
        }
      }
      firstFormItem.value = ''
      this.toolbar.formItems = []
      this.columns = []
      this.baseFormItems.splice(1, 1)
      this.$nextTick(() => {
        this.baseFormItems[0].value = val
        this.baseFormItems.push(firstFormItem)
      })
      // relBrandSelect.value=null;
      // relBrandSelect.url="/brandOrField/get";
      // relBrandSelect.param.type=obj.val;
      // relBrandSelect.queryAllCategory();
    },
    queryOptions(data) {
      var i = 0
      var formItems = this.toolbar.formItems
      if (!data) {
        var fields = []
        for (var item of formItems) {
          if (this.currSelectIdx < 0 || i > this.currSelectIdx) {
            if (item.component == 'form-select') {
              fields.push(item.prop)
            }
          }
          i++
        }
        if (fields.length == 0) return
        data = { ...this.queryFormObj, fields: fields.join(',') }
        delete data['PageSize']
        delete data['PageIndex']
      }
      var that = this
      var url = 'queryData/getFileDisdData'
      // 胎压中文
      const isTPMS = (data !== undefined && data !== null && data.bid === '5fed490ab6f2ea1bd409246d')
      if (isTPMS && (!that.$refs.table.query.hasOwnProperty('field12') || that.$refs.table.query.field12 === undefined)) {
          that.$refs.table.query.field12 = ''
      }
      that.$postObj(url, data, {}, {}, false).then(function (resp) {
        if (resp.data.code == 0) {
          var data = resp.data.data
           // 胎压中文只显示中国市场
           if (isTPMS && data.field12) {
            data.field12 = data.field12.filter(item => item === 'CN')
          }
          i = 0
          for (var item of formItems) {
            if (that.currSelectIdx < 0 || i > that.currSelectIdx) {
              item.bind.options = []
              var optionsArr = data[item.prop]
              if (optionsArr) {
                for (var optionObj of optionsArr) {
                  if (optionObj) {
                    item.bind.options.push({
                      label: optionObj,
                      value: optionObj,
                    })
                  }
                }
              }
            }
            i++
          }
        } else {
          that.$message(resp.data.msg)
        }
      })
    },
    removeReadOnly() {
      var seles = document.getElementsByClassName('el-select el-select--small')
      for (var obj of seles) {
        obj.getElementsByTagName('input')[0].removeAttribute('readonly')
      }
    },
    brandChange(objVal) {
      if (!objVal.val) {
        this.toolbar.formItems = []
        this.columns = []
        return
      }
      var that = this
      var url = 'brandOrField/getFiled'
      var data = {
        bid: objVal.val,
      }
      that.$post(url, data, {}, {}, false).then(function (resp) {
        if (resp.data.code == 0) {
          that.currSelectIdx = -1
          var data = resp.data.data
          if (data && data.length > 0) {
            that.queryFormObj = {
              PageIndex: that.queryFormObj.PageIndex,
              PageSize: that.queryFormObj.PageSize,
            }
            that.brandQueryForm.value = objVal.val
            const isTPMS = (objVal.val === '5fed490ab6f2ea1bd409246d')
            var clum = [],
              queryFormItem = []
            var fields = data
            // var strs="";
            var i = 0
            for (var obj of fields) {
              if (obj.query_clum) {
                if (obj.ele_type) {
                  let clumLabel = obj.clum_desc
                  if(!isTPMS || (clumLabel !== '零件号' && clumLabel !== '印刷号')) {
                      queryFormItem.push({
                      label: clumLabel,
                      prop: obj.clum_name,
                      labelWidth: 'auto',
                      bind: {
                        placeholder: '请输入',
                        style: 'min-width:210px;max-width:260px;',
                      },
                      on: {
                        input: () => {
                          clearTimeout(that.layElementQuery)
                          that.layElementQuery = setTimeout(() => {
                            that.$refs.table.query.PageIndex = 1
                            that.$refs.table.refreshData()
                            that.queryOptions()
                          }, 500)
                        },
                      },
                    })
                  }
                } else {
                  var changeEvt = function (val) {
                    that.currSelectIdx = this
                    that.queryFormObj[
                      that.toolbar.formItems[that.currSelectIdx].prop
                    ] = val
                    for (
                      var j = that.currSelectIdx + 1;
                      j < that.toolbar.formItems.length;
                      j++
                    ) {
                      if (
                        that.toolbar.formItems[j].component == 'form-select'
                      ) {
                        that.queryFormObj[that.toolbar.formItems[j].prop] = ''
                      }
                    }
                    that.$refs.table.query.PageIndex = 1
                    that.$refs.table.refreshData()
                    that.queryOptions()
                  }
                  queryFormItem.push({
                    label: obj.clum_desc,
                    prop: obj.clum_name,
                    labelWidth: '100px',
                    value: '',
                    component: 'form-select',
                    bind: {
                      clearable: true,
                      filterable: true,
                      options: [],
                    },
                    on: {
                      change: changeEvt.bind(i), //.native
                      'visible-change': (val) => {
                        if (val) {
                          var sels = document.getElementsByClassName(
                            'el-select-dropdown el-popper'
                          )
                          sels[sels.length - 1].style['min-width'] = '210px'
                          sels[sels.length - 1].style['max-width'] = '260px'
                        } else {
                          setTimeout(() => {
                            that.removeReadOnly()
                          }, 50)
                        }
                      },
                    },
                  })
                  // strs+=","+obj.clum_name
                }
                i++
              }
              let clumVal = {
                bind: {
                  label: obj.clum_desc,
                  prop: obj.clum_name,
                },
              }
              if(clumVal.bind.label === '年款') {
                clumVal.bind.minWidth = 130
              }
              if(clumVal.bind.label == '学习类型') {
                clumVal.header = {
                  component: 'relearn-header',
                  bind: { lang : 'CN'}
                }
              }
              clum.push(clumVal)
            }
            if(isTPMS) {
                // 零件号和印刷号合并
                queryFormItem.push({
                        label: '零件号或印刷号',
                        prop: 'ext_field1',
                        labelWidth: 'auto',
                        bind: {
                          placeholder: '请输入零件号或印刷号',
                          style: 'min-width:210px;max-width:260px;',
                        },
                        on: {
                          input: () => {
                            clearTimeout(that.layElementQuery)
                            that.layElementQuery = setTimeout(() => {
                              that.$refs.table.query.PageIndex = 1
                              that.$refs.table.refreshData()
                              that.queryOptions()
                            }, 500)
                          },
                        },
                      })
            }

            that.toolbar.formItems = queryFormItem
            that.columns = clum
            that.$nextTick(() => {
              that.$refs.table.query.bid = that.baseQueryFormObj.bid
              //刷新数据
              that.$refs.table.refreshData()
              // var data={
              //     bid:objVal.val,
              //     fields:strs.substring(1)
              // };
              //查询options数据
              that.queryOptions()
              //清除select input readonly属性
              that.removeReadOnly()
            })
          }
        } else {
          that.$message(resp.data.msg)
        }
      })
    },
  },
}
</script>
<style lang="less">
.index-query-dataen {
  .copySel {
    display: flex;
    padding: 20px 0px;
  }

  .copyLab {
    margin-left: 54px;
    margin-right: 10px;
    padding-top: 5px;
    text-align: right;
    font-size: 14px;
    color: #606266;
  }

  .select-max {
    max-width: 300px;
  }

  .el-table .cell {
    word-break: normal;
  }

  .el-form--inline .el-form-item {
    margin-right: 0;
  }
}
</style>